module.exports = __webpack_public_path__ + "static/media/1015047.967ad008.jpg";